module.exports = __webpack_public_path__ + "8f321bc28128c5ef630b35e30d348aac.png";